var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "modal-title" }, [
      _vm._v(" ADD THIRD PARTY CONNECTION ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sub-container" },
      [
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c("b-form-group", [
                  _c("label", [_vm._v(" Connection Name ")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    _vm._l(_vm.listPlugin, function(plugin) {
                      return _c(
                        "div",
                        {
                          key: plugin.plugin_name,
                          staticClass: "plugin-options",
                          class: {
                            "plugin-img-selected":
                              _vm.dataForm.plugin_name === plugin.plugin_name,
                            "error-border": _vm.$v.dataForm.plugin_name.$error
                          },
                          on: {
                            click: function($event) {
                              _vm.changeConnection(plugin)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "plugin-img",
                            attrs: {
                              alt: plugin.plugin_name,
                              src: plugin.logo
                                ? plugin.logo
                                : "@/assets/logo/privy.png"
                            }
                          })
                        ]
                      )
                    })
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          [
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-form-group",
                  {
                    class: {
                      "error-input": _vm.$v.dataForm.connection_name.$error
                    }
                  },
                  [
                    _c("label", [_vm._v(" Third Party Connection Name ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: {
                        disabled: _vm.isEdit,
                        placeholder: "Enter connection name here"
                      },
                      model: {
                        value: _vm.dataForm.connection_name,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "connection_name", $$v)
                        },
                        expression: "dataForm.connection_name"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { cols: "12" } },
              [
                _c(
                  "b-form-group",
                  {
                    class: { "error-input": _vm.$v.dataForm.environment.$error }
                  },
                  [
                    _c("label", [_vm._v(" Environment ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        options: _vm.listEnv,
                        placeholder: "Select environment here",
                        "value-format": "object",
                        label: "label"
                      },
                      model: {
                        value: _vm.dataForm.environment,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "environment", $$v)
                        },
                        expression: "dataForm.environment"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.listConfig.length > 0
              ? _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", [_vm._v(" Config ")]),
                        _vm._v(" "),
                        _vm._l(_vm.listConfig, function(data, index) {
                          return _c(
                            "div",
                            { key: index + 0, staticClass: "list-column-ui" },
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(
                                        "b-form",
                                        [
                                          _c("label", [_vm._v(" Name ")]),
                                          _vm._v(" "),
                                          _c("j-input", {
                                            attrs: { disabled: true },
                                            model: {
                                              value: data.name,
                                              callback: function($$v) {
                                                _vm.$set(data, "name", $$v)
                                              },
                                              expression: "data.name"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "12", md: "6" } },
                                    [
                                      _c(
                                        "b-form",
                                        [
                                          _c("label", [_vm._v(" Value ")]),
                                          _vm._v(" "),
                                          _c("j-input", {
                                            attrs: { placeholder: data.type },
                                            model: {
                                              value: data.value,
                                              callback: function($$v) {
                                                _vm.$set(data, "value", $$v)
                                              },
                                              expression: "data.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "m__t--20" },
      [
        _vm.isEdit
          ? _c(
              "b-button",
              { staticClass: "btn red", on: { click: _vm.deleteConn } },
              [_vm._v("\n      Delete\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "float-right" },
          [
            _c(
              "b-button",
              { staticClass: "btn m__r--5", on: { click: _vm.closeModal } },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              { staticClass: "btn blue", on: { click: _vm.submitForm } },
              [_vm._v("\n        Save\n      ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42762df4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42762df4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/third-party/jThirdPartyForm.vue
// module id = null
// module chunks = 